import script from "./ContentSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentSkeleton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__